export default function (toUrl, fromUrl, next) {
  next(
    function (vm) {
      let toPathMatched = toUrl.matched[toUrl.matched.length - 1].path;

      // Strip locale parameter from path for breadcrumb lookup
      // Convert "/:locale/clients" -> "/clients" or "/:locale" -> "/"
      let breadcrumbPath = toPathMatched.replace(/^\/:[^/]+/, "");
      if (breadcrumbPath === "") {
        breadcrumbPath = "/";
      }

      vm.$root.breadcrumbHandler(breadcrumbPath);
      //vm.$root.storeLatestUrl(toPathMatched);
    },
    toUrl,
    fromUrl
  );
}
